// Add your custom JS here.


const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};

window.addEventListener("resize", appHeight);
appHeight();

jQuery(document).ready(function () {
  // Function to adjust position of quote-progress based on scroll position and navbar height
  function adjustQuoteProgressPosition() {
    var scrollTop = jQuery(window).scrollTop();
    var navbarHeight = jQuery('.nav-container').height();
    var quoteProgress = jQuery('#quote-progress');

    if (scrollTop >= navbarHeight) {
      quoteProgress.css('top', '0');
    } else {
      quoteProgress.css('top', (navbarHeight - scrollTop) + 'px');
    }
  }

  // Code for .navbar-toggler click event
  jQuery(".navbar-toggler").click(function () {
    var viewportWidth = jQuery(window).width();

    if (viewportWidth < 768) {
      var mainNav = jQuery("#main-nav");

      mainNav.toggleClass("menu-bg");

      jQuery(".menu-contact").addClass("fade-in");

      // Remove "fade-in" class after a delay
      setTimeout(function () {
        jQuery(".menu-contact").removeClass("fade-in");
      }, 8500); // 3000 milliseconds delay (adjust as needed)
    }
  });

  // Code for .nav-container scroll behavior
  var navContainer = jQuery(".nav-container");

  jQuery(window).on("scroll", function () {
    navContainer.toggleClass(
      "scrolled",
      jQuery(window).scrollTop() >= navContainer.height()
    );

    // Adjust position of quote-progress based on scroll position and navbar height
    adjustQuoteProgressPosition();
  });

  // Update navbar height when window is resized
  jQuery(window).on("resize", function () {
    adjustQuoteProgressPosition();
  });
});


jQuery(document).ready(function ($) {
  // Show default tab on page load
  $("#residential").show();
  $(".service-button[data-tab='residential']").addClass("active"); // Add 'active' class to default tab
  $(".service-container").addClass("residential-bg"); // Set default background color

  // Handle tab button click
  $(".service-button").click(function () {
    $(".service-button").removeClass("active");
    $(this).addClass("active");

    var tabId = $(this).data("tab");
    $(".content-tab").hide();
    $("#" + tabId).fadeIn();

    // Change service container background based on selected tab
    if (tabId === "residential") {
      $(".service-container")
        .removeClass("commercial-bg")
        .addClass("residential-bg");
    } else if (tabId === "commercial") {
      $(".service-container")
        .removeClass("residential-bg")
        .addClass("commercial-bg");
    }

    // Apply fade transition to buttons
    $(".service-button").css({
      transition:
        "background-color 0.5s ease-in-out, opacity 0.75s ease-in-out",
      opacity: "0.5",
    });
    $(this).css("opacity", "1");
  });
});
